'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import 'react-dates/initialize.js';
import * as React from 'react';
import classnames from 'classnames';
import { nanoid } from 'nanoid';
import { SingleDatePicker } from 'react-dates';
import { FieldNote, Icon, TextPassage } from '../../index.js';
export const Datepicker = (_a) => {
    var { className, id, label, modalHeaderLabel = 'Date', onDateChange, date, isDayBlocked, isOutsideRange, numberOfMonths, fieldNote, isError, disabled, calendarInfoPosition, renderCalendarInfo, withFullScreenPortal: useMobileModal } = _a, other = __rest(_a, ["className", "id", "label", "modalHeaderLabel", "onDateChange", "date", "isDayBlocked", "isOutsideRange", "numberOfMonths", "fieldNote", "isError", "disabled", "calendarInfoPosition", "renderCalendarInfo", "withFullScreenPortal"]);
    const [dateVar, setDate] = React.useState(null);
    const [modalIsOpen, setModalIsOpen] = React.useState(false);
    const [focused, setFocused] = React.useState(false);
    const [keepFloating, setkeepFloating] = React.useState(false);
    const [idVar, setId] = React.useState(id || '');
    const [isValidError, setIsError] = React.useState(false);
    const [numberOfMonthsVar, setNumberOfMonthsVar] = React.useState(numberOfMonths);
    const [withFullScreenPortal, setWithFullScreenPortal] = React.useState(false);
    const [orientationAr, setOrientationAr] = React.useState(undefined);
    const erroring = isValidError || isError;
    const componentClassName = classnames('sparky-c-datepicker', className, {
        'sparky-c-text-field--floating-label': true,
        'sparky-c-text-field': true,
        'sparky-is-disabled': disabled,
        'sparky-is-error': erroring,
    });
    const setVerticalHeight = numberOfMonths && numberOfMonths > 1 ? 600 : 296;
    const changeDate = (date) => {
        if (!date) {
            setIsError(true);
        }
        else {
            setIsError(false);
        }
        setDate(date);
        onDateChange === null || onDateChange === void 0 ? void 0 : onDateChange(date);
        setkeepFloating(!!date);
    };
    function useWindowSize() {
        const [size, setSize] = React.useState(0);
        React.useLayoutEffect(() => {
            function updateSize() {
                setSize(window.innerWidth);
            }
            window.addEventListener('resize', updateSize);
            updateSize();
            return () => window.removeEventListener('resize', updateSize);
        }, []);
        return size;
    }
    const width = useWindowSize();
    React.useEffect(() => {
        setDate(date);
        setkeepFloating(!!date);
    }, [date]);
    React.useEffect(() => {
        setId(id || nanoid());
    }, [id]);
    React.useEffect(() => {
        const singleDatePickerEl = document.querySelector('.SingleDatePicker_picker__fullScreenPortal');
        setModalIsOpen(!!singleDatePickerEl);
    });
    React.useEffect(() => {
        if (width > 768) {
            setNumberOfMonthsVar(numberOfMonths);
            setWithFullScreenPortal(false);
            setOrientationAr('horizontal');
        }
        else {
            setNumberOfMonthsVar(12);
            setWithFullScreenPortal(true);
            setOrientationAr('vertical');
        }
    }, [numberOfMonths, withFullScreenPortal, orientationAr, width]);
    return (_jsx("div", Object.assign({ className: componentClassName }, { children: _jsxs("label", Object.assign({ htmlFor: idVar, className: keepFloating
                ? 'sparky-c-text-field__label-wrapper sparky-c-text-field__label-wrapper--floating'
                : 'sparky-c-text-field__label-wrapper' }, { children: [_jsx(TextPassage, Object.assign({ className: "sparky-c-text-field__label" }, { children: label })), modalIsOpen && (_jsx(TextPassage, Object.assign({ className: "sparky-c-datepicker__modal-header__label" }, { children: modalHeaderLabel }))), _jsx(SingleDatePicker, Object.assign({}, other, { date: dateVar, onDateChange: (date) => changeDate(date), focused: focused, onFocusChange: ({ focused }) => setFocused(focused), numberOfMonths: numberOfMonthsVar, id: idVar, hideKeyboardShortcutsPanel: true, showDefaultInputIcon: true, inputIconPosition: "after", withFullScreenPortal: useMobileModal !== null && useMobileModal !== void 0 ? useMobileModal : withFullScreenPortal, block: true, disabled: disabled, navPrev: _jsx(Icon, { name: "chevron-left" }), navNext: _jsx(Icon, { name: "chevron-right" }), customInputIcon: erroring ? (_jsxs("div", Object.assign({ className: "sparky-c-datepicker__icon-wrapper" }, { children: [_jsx(Icon, { className: "sparky-c-text-field__status-icon", name: "exclamation-circle-fill", size: "sm" }), _jsx(Icon, { name: "calendar-outline" })] }))) : (_jsx(Icon, { name: "calendar-outline" })), isDayBlocked: isDayBlocked, isOutsideRange: isOutsideRange, onNextMonthClick: () => setkeepFloating(true), onPrevMonthClick: () => setkeepFloating(true), onClose: (arg) => setkeepFloating(erroring ? true : !!arg.date), verticalHeight: setVerticalHeight, orientation: orientationAr, calendarInfoPosition: calendarInfoPosition, renderCalendarInfo: renderCalendarInfo })), erroring && fieldNote && (_jsx(FieldNote, Object.assign({ className: "sparky-c-counter-field__note", isError: isError }, { children: fieldNote })))] })) })));
};
//# sourceMappingURL=Datepicker.js.map